import { createUseStyles } from "react-jss";
import colors from "../../../constants/colors";

const styles = createUseStyles({
  buttonGroup: {
    marginTop: "auto",
    fontSize: ".95rem",
    fontWeight: "bold",
    padding: 20,
    borderTopWidth: 1,
    borderTopColor: colors.menu.border,
    borderTopStyle: "solid",
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  "@media (max-width: 768px)": {
    buttonGroup: {
      flexDirection: "column-reverse",
      justifyContent: "space-around",
      gap: 8,
      padding: "16px 24px",
      paddingBottom: "max(16px, env(safe-area-inset-bottom))",
      flex: "0 0 auto",
    },
  },
});

export default styles;
